import React, { Component } from 'react';
// Customizable Area Start
import { Snackbar } from "@material-ui/core";
import Alert from '@material-ui/lab/Alert';

// Customizable Area End
export interface HasSuccessErrorType {
  isOpen: boolean;
  isSeverity: 'success' | 'info' | 'warning' | 'error';
  isMessage: string;
}

export interface Props {
  // Customizable Area Start
  snackBarProps: HasSuccessErrorType;
  handleCloseSnack: () => void | undefined
  // Customizable Area End
}

export default class SnackBarAlert extends Component<
  Props
> {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  // Customizable Area End

  render() {
    return (
      // Customizable Area Start
      <>
        {this.props.snackBarProps.isOpen && (
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "left" }}
            style={{ zIndex: 9999999 }}
            open={this.props.snackBarProps.isOpen}
            onClose={this.props.handleCloseSnack}
            autoHideDuration={6000}
          >
            <Alert data-testid="snackBarCloseTestId" onClose={this.props.handleCloseSnack} severity={this.props.snackBarProps.isSeverity}>
              {this.props.snackBarProps.isMessage}
            </Alert>
          </Snackbar>
        )}
      </>
      // Customizable Area End
    );
  }
}

// Customizable Area Start
export { SnackBarAlert }
// Customizable Area End